import { Card, Col, Row, Skeleton, Space } from "antd";
import Meta from "antd/lib/card/Meta";
import Paragraph from "antd/lib/typography/Paragraph";
import { Fragment, ReactNode } from "react";
import { useNavigate } from "react-router";
import { SearchOutlined } from "@ant-design/icons";
import Title from "antd/lib/typography/Title";

export interface GridListDataSource {
    key: string;
    title: string | ReactNode;
    description?: string | ReactNode;
    avatar?: ReactNode;
    tags?: {
        position: string;
        value: ReactNode;
    }[];
    link?: string;
    disabled?: boolean;
    className?: string;
    pack?: string;          // "free" | "starter" | "advanced"
    group?: "resources" | "templates";
    repoUrl?: string;
}
export interface GridListProps {
    dataSource: GridListDataSource[];
    loading?: boolean;
    navigateState?: object;
    disableEmptyState?: boolean;
    itemsInRow?: 2 | 3 | 4 | 6 | 8;
    hoverable?: boolean;
}

const GridList = ({
    dataSource,
    loading,
    navigateState,
    disableEmptyState,
    itemsInRow,
    hoverable
}: GridListProps) => {
    const navigate = useNavigate();

    return (
        <div className="grid-list">
            {
                loading ? <Skeleton /> :
                    <>
                        {dataSource && dataSource.length ?
                            <Row gutter={[24, 24]}>
                                {dataSource.map(item => (
                                    <Col xs={24} sm={12} md={8} lg={itemsInRow ? 24 / itemsInRow : 8} style={{ display: "inline-flex", alignSelf: "stretch" }} key={item.key}>
                                        <Card
                                            bordered
                                            hoverable={hoverable === undefined ? true : hoverable}
                                            className={(() => {
                                                const customClasses = ["grid-list-card"];
                                                item.className && customClasses.push(item.className);
                                                item.disabled && customClasses.push("ant-card-disabled");
                                                return customClasses.join(" ");
                                            })()}
                                            onClick={() => item.link && navigate(item.link, navigateState)} style={{ width: "100%" }}
                                        >
                                            <Meta
                                                title={
                                                    <>
                                                        <Space className="flex-align-center">
                                                            {item.avatar}
                                                            <div style={{ lineHeight: "18px" }}>
                                                                <div style={{ whiteSpace: "break-spaces" }}>
                                                                    {item.title}
                                                                </div>
                                                                {
                                                                    (item.tags || [])
                                                                        .filter(item => item.position === "top")
                                                                        .map((tag, index) => <Fragment key={index}>{tag.value}</Fragment>)
                                                                }
                                                            </div>
                                                        </Space>
                                                    </>
                                                }
                                                description={
                                                    <Paragraph ellipsis={{ rows: 2 }} style={{ color: "GrayText" }}>
                                                        {item.description}
                                                    </Paragraph>
                                                }
                                            />
                                            <div className="ant-card-footer">
                                                {
                                                    (item.tags || [])
                                                        .filter(item => item.position === "bottom")
                                                        .map((tag, index) => <Fragment key={index}>{tag.value}</Fragment>)
                                                }
                                            </div>
                                        </Card>
                                    </Col>
                                ))}
                            </Row> :
                            !disableEmptyState ?
                                <div style={{ textAlign: "center", marginTop: 20 }}>
                                    <SearchOutlined style={{ fontSize: 60, verticalAlign: "middle", color: "#244460" }} />
                                    <Title level={5}>It looks like there are no matching results found</Title>
                                    <p style={{ color: "black" }}>Please try another search</p>
                                </div> :
                                undefined
                        }</>
            }
        </div>
    )
}

export default GridList;